import { render } from "./business.html?vue&type=template&id=2b47b3ec&scoped=true&ts=true"
import script from "./business.ts?vue&type=script&lang=ts"
export * from "./business.ts?vue&type=script&lang=ts"

import "./business.scss?vue&type=style&index=0&id=2b47b3ec&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b47b3ec"]])

export default __exports__